import z from 'zod';
import { MortgageContext } from '../contexts';
import { createRoute } from '../functions/createRoute';
export const MortgageIntentRoute = createRoute('mortgage-intent', {
    path: '/intent',
    schema: z.object({}),
    exact: false,
    context: MortgageContext,
});
export const MortgageFinancingRoute = createRoute('mortgage-financing', {
    path: '/financing',
    schema: z.object({}),
    exact: false,
    context: MortgageContext,
});
export const MortgagePreInquiryRoute = createRoute('mortgage-pre-inquiry', {
    path: '/pre-inquiry',
    schema: z.object({}),
    exact: false,
    context: MortgageContext,
});
export const MortgageOfferRoute = createRoute('mortgage-offer', {
    path: '/offer',
    schema: z.object({}),
    exact: false,
    context: MortgageContext,
});
export const MortgageDocumentsRoute = createRoute('mortgage-documents', {
    path: '/documents',
    schema: z.object({}),
    exact: false,
    context: MortgageContext,
});
export const MortgageLogbookRoute = createRoute('mortgage-logbook', {
    path: '/logbook',
    schema: z.object({}),
    exact: false,
    context: MortgageContext,
});
export const MortgageCommunicationRoute = createRoute('mortgage-communication', {
    path: '/communication',
    schema: z.object({}),
    exact: false,
    context: MortgageContext,
});
export const MortgageConfigurationRoute = createRoute('mortgage-configuration', {
    path: '/configuration',
    schema: z.object({}),
    exact: false,
    context: MortgageContext,
});
